import { Select } from 'antd';
import styled from 'styled-components';

export const StyledMainDiv = styled('div')`
  display: flex;
  margin-top: 1rem;
  padding: 10px 0;
`;

export const StyledSpan = styled('span')<{ scheme?: string }>`
  width: 400px;
  color: ${({ scheme }) =>
    scheme === 'darkUITheme'
      ? '#ffffff'
      : scheme === 'deepBlueTheme' || scheme === 'deepNavyTheme'
      ? '#000000'
      : '#000000'};
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
`;

export const StyledSelect = styled(Select)`
  width: 200px;
  margin-right: 10px;

  .ant-select-dropdown {
    min-width: 600px !important;
    max-width: 600px !important;
    max-height: 300px !important;
    min-height: 100px !important;
  }

  .ant-select-dropdown .rc-virtual-list {
    max-height: 300px !important;
    min-height: 100px !important;
  }

  .ant-select-dropdown .ant-select-item {
    min-height: 50px !important;
    height: auto !important;
    padding: 12px 16px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    line-height: 1.5 !important;
    display: flex !important;
    align-items: flex-start !important;
  }

  .ant-select-dropdown .ant-select-item-option-content {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    width: 100% !important;
    flex: 1 !important;
  }
`;
